export interface MDPartyDetail {
    partyCode: string | undefined, 
    description: string | undefined,
    siteCode: string | undefined,
    defaultSalesBook: string | undefined,
    lei: string | undefined,
    ccn: string | undefined,
    bondTierId: string | undefined,
    bondTierName: string | undefined,
    irsTierId: string | undefined,
    irsTierName: string | undefined,
    tomsCode: string | undefined,
    tnpCode: string | undefined,
    maCode: string | undefined,
    twCode: string | undefined,
    twirsCode: string | undefined,
    eurexCode: string | undefined,
    mtsCode: string | undefined,
}

const defaultMDPartyDetail : MDPartyDetail = {
    partyCode: "",
    description: "",
    siteCode: "",
    defaultSalesBook: "",
    lei: "",
    ccn: "",
    bondTierId: "",
    bondTierName: "",
    irsTierId: "",
    irsTierName: "",
    tomsCode: "",
    tnpCode: "",
    maCode: "",
    twCode: "",
    twirsCode: "",
    eurexCode: "",
    mtsCode: "",
}

export const createEmptyMDPartyDetail = () => {
    return  { ...defaultMDPartyDetail };
}